export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5800.d11a2c6d.jpg";